module.exports = __webpack_public_path__ + "static/media/left.fec6a1da.svg";